/**
 * Simple rules for QInput and QSelect
 * @returns {
 *    required: field is required
 *    moreThanZero: value must be more than 0
 * }
 */
const generalRulesPlugin = () => {
    const notNull = (val) => val !== null && val !== undefined || 'This field is required';
    const required = (val) => !!val || 'This field is required';
    const moreThanZero = (val) => (val > 0) || 'Value must be more than 0';
    const validEmail = (v) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v) || 'E-mail must be valid';
    return {
        notNull,
        required,
        moreThanZero,
        validEmail
    };
};
export { generalRulesPlugin };
